import http from './public'

var pub = "/api/common/inspectcategory/"

export const queryInspectCategoryList = (params) => { //查询安责险巡查种类列表
    return http(`${pub}queryInspectCategoryList`, params)
}

export const queryInspectCategoryDetail = (params) => { //查询巡查种类详情
    return http(`${pub}queryInspectCategoryDetail`, params)
}
export const addInspectCategoryInfo = (params) => { //新增巡查种类信息
    return http(`${pub}addInspectCategoryInfo`, params)
}
export const editInspectCategoryInfo = (params) => { //修改巡查种类信息
    return http(`${pub}editInspectCategoryInfo`, params)
}
export const delInspectCategoryInfo = (params) => { //删除巡查种类信息
    return http(`${pub}delInspectCategoryInfo`, params)
}
